import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.jpg";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function Register() {
  let navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [messageError, setmessageError] = useState("");

  // Registration logic
  async function handleRegister(values) {
    try {
      setisLoading(true);
      let { data } = await axios.post(
        `https://api.elza2.store/api/v1/auth/signUp`,
        values
      );

      if (data.status === "success") {
        setisLoading(false);
        navigate("/login");
      }
    } catch (err) {
      setisLoading(false);
      setmessageError(
        `${err.response?.data?.errors?.param || "Error"}: ${
          err.response?.data?.errors?.msg || "Something went wrong"
        }`
      );
    }
  }

  // Validation schema using Yup
  let validationSchema = Yup.object({
    name: Yup.string()
      .required("Name is required")
      .min(3, "Name must be at least 3 characters")
      .max(100, "Name can't be longer than 15 characters"),
    email: Yup.string().required("Email is required").email("Email is invalid"),
    phone: Yup.string()
      .required("Phone is required")
      .matches(/^01[0125][0-9]{8}$/, "Phone must be an Egyptian number"),
    password: Yup.string()
      .required("Password is required"),
    rePassword: Yup.string()
      .required("Re-entering the password is required")
      .oneOf([Yup.ref("password")], "Passwords do not match"),
  });

  let formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      password: "",
      rePassword: "",
    },
    validationSchema,
    onSubmit: handleRegister,
  });

  return (
    <div className="min-h-screen flex flex-col lg:flex-row relative">
      <Link to="/">
        <button className="absolute z-10 top-4 left-4 bg-white text-black py-2 px-4 rounded-lg hover:bg-blue-600">
          <IoMdArrowRoundBack />
        </button>
      </Link>
      {/* Left half: Form */}
      <div className="bg-image w-full lg:w-1/2 flex items-center justify-center bg-gray-900 p-8">
        <div className="w-full bg-white max-w-md space-y-8 bg-gray-800 shadow rounded-lg p-8">
          <h2 className="text-center text-3xl font-bold text-gray">
            Register Now
          </h2>
          <p className="text-center text-gray-400">Create your account</p>

          {messageError && (
            <div className="alert alert-danger bg-red-500 text-gray">
              {messageError}
            </div>
          )}

          <form className="mt-8 space-y-6" onSubmit={formik.handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="name" className="sr-only">
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  placeholder="Full Name"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                />
                {formik.errors.name && formik.touched.name ? (
                  <div className="text-red-500 text-sm">
                    {formik.errors.name}
                  </div>
                ) : null}
              </div>
              <div>
                <label htmlFor="email" className="sr-only">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  placeholder="Email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                {formik.errors.email && formik.touched.email ? (
                  <div className="text-red-500 text-sm">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>
              <div>
                <label htmlFor="phone" className="sr-only">
                  Phone
                </label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  placeholder="Phone"
                  onChange={formik.handleChange}
                  value={formik.values.phone}
                />
                {formik.errors.phone && formik.touched.phone ? (
                  <div className="text-red-500 text-sm">
                    {formik.errors.phone}
                  </div>
                ) : null}
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  placeholder="Password"
                  onChange={formik.handleChange}
                  value={formik.values.password}
                />
                {formik.errors.password && formik.touched.password ? (
                  <div className="text-red-500 text-sm">
                    {formik.errors.password}
                  </div>
                ) : null}
              </div>
              <div>
                <label htmlFor="rePassword" className="sr-only">
                  Re-enter Password
                </label>
                <input
                  id="rePassword"
                  name="rePassword"
                  type="password"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  placeholder="Confirm Password"
                  onChange={formik.handleChange}
                  value={formik.values.rePassword}
                />
                {formik.errors.rePassword && formik.touched.rePassword ? (
                  <div className="text-red-500 text-sm">
                    {formik.errors.rePassword}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="flex items-center justify-between">
              <div className="text-sm">
                <Link
                  to="/login"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Have an account, Login
                </Link>
              </div>
            </div>
            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {isLoading ? <span className="loader"></span> : "Register"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Right half: Image */}
      <div className="w-full lg:w-1/2 flex items-center justify-center bg-gray-900">
        <div className="relative">
          <img src={logo} alt="Logo" className="max-w-full h-auto" />
        </div>
      </div>
    </div>
  );
}
